
<Container direction="column" :gap="2" :padding="0" overflow="visible">
	<Container :gap="6" :padding="0">
		<Icon name="i-globe" type="filled" state="light" size="x-small" />
		<Typography type="p3" color="light" weight="bold" overflow="ellipsis">
			{{ series.name }}
		</Typography>
	</Container>
	<Container :gap="8" :padding="0" overflow="visible">
		<Typography class="sparkline-value" type="p1" color="dark" weight="bold" overflow="ellipsis">
			246 ms
		</Typography>
		<div ref="sparkline" class="flow-sparkline" :style="styleObj" />
	</Container>
</Container>
